<template>
  <div>
    <div v-if="show">
      <div id="video">
        <wv-popup :visible.sync="popupVisible3" height="100%" style="overflow: auto;padding-bottom: 60px;">
          <h2 class="fx_title">选择您要分享的课程</h2>
          <wv-group>
            <wv-cell v-for="(item,idx) in videoData" :key="idx" :title="examList[item.examId].name"
                     @click="share_detail(videoData[idx])"
                     is-link/>
          </wv-group>
          <div class="fx_block" @click="popupVisible3=false">
            <span>关闭</span>
          </div>
        </wv-popup>

        <wv-popup :visible.sync="popupVisible2" height="100%" style="overflow: auto;padding-bottom: 60px;">

          <div class="jm_text">加盟请拨打此电话：<span>13759120015</span></div>

          <div class="fx_block" @click="popupVisible2=false">
            <span>关闭</span>
          </div>
        </wv-popup>

        <div v-on:click="showCover"
             style="width:100vw;height:100vh;position:fixed;z-index:10000;left:0px;top:0px;background-color:rgba(0, 0, 0, 0.52);"
             v-if="showcover_state">
          <img src="../assets/pic_hd.jpg" style="width: 50vw;height: auto;float: right;margin-right: 5vw;"/>
        </div>
        <div class="list_box" v-if="freevideoData.length">
          <div class="list_video">
            <ul>
              <li v-for="item in freevideoData" v-on:click="event_detail(item)">
                <a href="javascript:void(0)">
                  <div class="kc_video">
                    <img v-bind:src="item.image"/>
                  </div>
                  <span>{{item.subject}}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <!-- 	<div class="yq_box" @click="popupVisible3=true" v-if="userInfo.driver_level.distribution">
			  <a href="javascript:void(0)">
				<img src="../assets/yq.jpg" alt="邀请学员">
			  </a>
			</div> -->

        <div class="btn_box" v-if="userInfo.driver_level.distribution">
          <ul>
            <li><a @click="popupVisible3=true">分享</a></li>
            <li><a @click="popupVisible2=true">加盟合作</a></li>
          </ul>
        </div>
        <ul class="nav_list" id="navlist">
          <li :class="{'active':km==3}" @click="tabaction(3)"> 科目三</li>
          <li :class="{'active':km==2}" @click="tabaction(2)">科目二</li>
        </ul>
        <div class="xz_box">
          <ul>
            <li v-on:click="addressPickerShow = true">
              当前选择：{{address | pickerValueFilter}}
              <i class="iconfont icon-right"></i>
            </li>
            <li v-on:click="examinationPicker = true">
              {{exam_change[0].name}}
              <i class="iconfont icon-right"></i>
            </li>
          </ul>
        </div>
        <div class="kc_list" v-for="(item,idx) in videoData" :key="idx">
          <div class="kc_title">
            <h2>{{examList[item.examId].name}}</h2>
          </div>
          <!--  科目三 -->
          <div class="video_list" v-if="videoData[idx].km3.length">
            <ul>
              <li v-for="item in videoData[idx].km3" v-on:click="event_detail(item)" v-if="item.free==1">
                <a>
                  <div class="kc_video">
                    <img v-bind:src="item.image"/>
                  </div>
                  <div class="kc_btbox">
                    <h4>{{item.subject}}</h4>
                    <p>{{item.description}}</p>
                    <div class="kc">
                      免费观看
                      <div>
                        <span>
                          <i class="iconfont icon-guankan"></i>{{item.view}}
                        </span>
                        <span>
                          <i class="iconfont icon-pinglun"></i>{{item.comment_number}}
                        </span>
                      </div>
                    </div>
                  </div>
                </a>
              </li>

              <li v-for="item in videoData[idx].km3" v-on:click="event_detail(item)" v-if="item.free==0">
                <a>
                  <div class="kc_video">
                    <img v-bind:src="item.image"/>
                  </div>
                  <div class="kc_btbox">
                    <h4>{{item.subject}}</h4>
                    <p>{{item.description}}</p>
                    <div class="kc">
                      <span style="font-size: 3.2vw;color: #1accf9;" v-if="userInfo.driver_level.distribution">可获得60%收益</span><a
                      v-on:click.stop="popupVisible3=true" v-if="userInfo.driver_level.distribution" style="float:right;height:0.46rem;width:35%;color:#FFFFFF;line-height:0.46rem;text-align:center;background-color:#00b8ff;border-radius:0.9rem;border:0px;display:inline-block;">转发分享</a>
                      <span style="font-size: 3.2vw;color: #1accf9;" v-if="!userInfo.driver_level.distribution">{{userInfo | paytxt}}</span>
                      <div v-if="!userInfo.driver_level.distribution">
        		  			              <span>
        		  			                <i class="iconfont icon-guankan"></i>{{item.view}}
        		  			              </span>
                        <span>
        		  			                <i class="iconfont icon-pinglun"></i>{{item.comment_number}}
        		  			              </span>
                      </div>
                    </div>
                  </div>
                </a>
              </li>
            </ul>
          </div>
          <!--  科目二 教学视频 -->
          <div class="video_list" v-if="videoData[idx].km2_0.length">
            <h3><span>教学视频</span></h3>
            <ul>
              <li v-for="item in videoData[idx].km2_0" v-on:click="event_detail(item)" v-if="item.free==1">
                <a>
                  <div class="kc_video">
                    <img v-bind:src="item.image"/>
                  </div>
                  <div class="kc_btbox">
                    <h4>{{item.subject}}</h4>
                    <p>{{item.description}}</p>
                    <div class="kc">
                      免费观看
                      <div>
                        <span>
                          <i class="iconfont icon-guankan"></i>{{item.view}}
                        </span>
                        <span>
                          <i class="iconfont icon-pinglun"></i>{{item.comment_number}}
                        </span>
                      </div>
                    </div>
                  </div>
                </a>
              </li>

              <li v-for="item in videoData[idx].km2_0" v-on:click="event_detail(item)" v-if="item.free==0">
                <a>
                  <div class="kc_video">
                    <img v-bind:src="item.image"/>
                  </div>
                  <div class="kc_btbox">
                    <h4>{{item.subject}}</h4>
                    <p>{{item.description}}</p>
                    <div class="kc">
                      <span style="font-size: 3.2vw;color: #1accf9;" v-if="userInfo.driver_level.distribution">可获得60%收益</span><a
                      v-on:click.stop="popupVisible3=true" v-if="userInfo.driver_level.distribution" style="float:right;height:0.46rem;width:35%;color:#FFFFFF;line-height:0.46rem;text-align:center;background-color:#00b8ff;border-radius:0.9rem;border:0px;display:inline-block;">转发分享</a>
                      <span style="font-size: 3.2vw;color: #1accf9;" v-if="!userInfo.driver_level.distribution">{{userInfo | paytxt}}</span>
                      <div v-if="!userInfo.driver_level.distribution">
        		  			              <span>
        		  			                <i class="iconfont icon-guankan"></i>{{item.view}}
        		  			              </span>
                        <span>
        		  			                <i class="iconfont icon-pinglun"></i>{{item.comment_number}}
        		  			              </span>
                      </div>
                    </div>
                  </div>
                </a>
              </li>
            </ul>
          </div>

          <!--  科目二 考场视频 -->
          <div class="video_list" v-if="videoData[idx].km2_1.length">
            <h3><span>考场视频</span></h3>
            <ul>
              <li v-for="item in videoData[idx].km2_1" v-on:click="event_detail(item)" v-if="item.free==1">
                <a>
                  <div class="kc_video">
                    <img v-bind:src="item.image"/>
                  </div>
                  <div class="kc_btbox">
                    <h4>{{item.subject}}</h4>
                    <p>{{item.description}}</p>
                    <div class="kc">
                      免费观看
                      <div>
                        <span>
                          <i class="iconfont icon-guankan"></i>{{item.view}}
                        </span>
                        <span>
                          <i class="iconfont icon-pinglun"></i>{{item.comment_number}}
                        </span>
                      </div>
                    </div>
                  </div>
                </a>
              </li>

              <li v-for="item in videoData[idx].km2_1" v-on:click="event_detail(item)" v-if="item.free==0">
                <a>
                  <div class="kc_video">
                    <img v-bind:src="item.image"/>
                  </div>
                  <div class="kc_btbox">
                    <h4>{{item.subject}}</h4>
                    <p>{{item.description}}</p>
                    <div class="kc">
                      <span style="font-size: 3.2vw;color: #1accf9;" v-if="userInfo.driver_level.distribution">可获得60%收益</span><a
                      v-on:click.stop="popupVisible3=true" v-if="userInfo.driver_level.distribution" style="float:right;height:0.46rem;width:35%;color:#FFFFFF;line-height:0.46rem;text-align:center;background-color:#00b8ff;border-radius:0.9rem;border:0px;display:inline-block;">转发分享</a>
                      <span style="font-size: 3.2vw;color: #1accf9;" v-if="!userInfo.driver_level.distribution">{{userInfo | paytxt}}</span>
                      <div v-if="!userInfo.driver_level.distribution">
        		  			              <span>
        		  			                <i class="iconfont icon-guankan"></i>{{item.view}}
        		  			              </span>
                        <span>
        		  			                <i class="iconfont icon-pinglun"></i>{{item.comment_number}}
        		  			              </span>
                      </div>
                    </div>

                  </div>
                </a>
              </li>
            </ul>
          </div>

        </div>
        <div class="back_box">
          <a v-if="userInfo.driver_level.distribution" class="iconfont icon-fenxiang1 fx_btn active"
             @click="popupVisible3=true"></a>
          <a class="iconfont icon-fanhuishouye index_btn active" @click="goTo('/')"></a>
          <span class="active" @click="fx_click()"></span>
        </div>
      </div>
    </div>
    <wv-picker :visible.sync="examinationPicker" :columns="examination" v-model="exam_change" value-key="name"
               @confirm="examinationConfirm"/>
    <wv-picker :visible.sync="addressPickerShow" v-model="address_change" ref="addressPicker" :columns="addressColumns"
               :visible-item-count="5" @change="onAddressChange" @confirm="confirmAddress"/>
  </div>

</template>

<script>
    import chinaAreaData from 'china-area-data'

    const provinces = Object.values(chinaAreaData[86])
    // 获取某一省下的市
    const getCities = (province) => {
        let provinceCode
        for (let i in chinaAreaData[86]) {
            if (province === chinaAreaData[86][i]) {
                provinceCode = i
                break
            }
        }
        return typeof chinaAreaData[provinceCode] === 'object' ? Object.values(chinaAreaData[provinceCode]) : []
    }

    // 获取某一市下的区/县
    function getAreas(province, city) {
        let provinceCode, cityCode
        for (let i in chinaAreaData[86]) {
            if (province === chinaAreaData[86][i]) {
                provinceCode = i
                break
            }
        }
        for (let i in chinaAreaData[provinceCode]) {
            if (city === chinaAreaData[provinceCode][i]) {
                cityCode = i
                break
            }
        }
        if (chinaAreaData[cityCode]) {
            return typeof chinaAreaData[cityCode] === 'object' ? Object.values(chinaAreaData[cityCode]) : []
        } else {
            // 只有两级的情况
            return []
        }
    }


    import {
        swiper,
        swiperSlide
    } from 'vue-awesome-swiper'

    export default {
        data() {
            return {
                show: false,
                km: 3,
                ct: 'C1/C2/C3',
                marker: {},
                kefu: [],
                compenstateList: [],
                advList: [],
                attachments: [],
                objectMultiArray: [],
                videoData: {},
                swiperOption: {
                    slidesPerView: 'auto',
                    centeredSlides: true,
                    spaceBetween: 10,
                    loop: true,
                    speed: 600, //config参数同swiper4,与官网一致
                    autoplay: true
                },
                swiperOptionCompencate: {
                    direction: 'vertical',
                    slidesPerView: 'auto',
                    centeredSlides: true,
                    spaceBetween: 0,
                    loop: true,
                    speed: 600, //config参数同swiper4,与官网一致
                    autoplay: true
                },
                loaded: false,
                examination: [{
                    values: []
                }],
                examIndex: 0,
                exam_change: [{
                    name: '全部考场',
                    value: 0
                }],
                exam: [{
                    name: '全部考场',
                    value: 0
                }],
                examinationPicker: false,
                addressPickerShow: false,
                addressColumns: [{
                    values: provinces
                },
                    {
                        values: getCities('云南省')
                    }
                ],
                address_change: ['云南省', '昆明市'],
                address: ['云南省', '昆明市'],
                freevideoData: [],

                showcover_state: false,
                htmlUrl: '',
                isFakeData: true,
                popupVisible3: false,
                popupVisible2: false,
                userInfo: {
                    driver_level: {
                        distribution: 0
                    }
                }
            }
        },
        filters: {
            pickerValueFilter(val) {
                if (Array.isArray(val)) {
                    return val.toString()
                } else {
                    return '请选择'
                }
            },
            paytxt(val) {
                if (val.user_video_level_id) {
                    return '免费观看';
                } else {
                    return '付费观看';
                }
            }
        },
        components: {
            swiper,
            swiperSlide
        },
        methods: {
            showCover: function () {
                console.log(7777);
                this.showcover_state = !this.showcover_state;
            },
            onAddressChange(picker, addressValues, slotIndex) {
                if (slotIndex === 0) {
                    const cities = getCities(addressValues[0])
                    picker.setColumnValues(1, cities)
                    //picker.setColumnValues(2, getAreas(addressValues[0], cities[0]))
                } else if (slotIndex === 1) {
                    //picker.setColumnValues(2, getAreas(addressValues[0], addressValues[1]))
                }
            },
            confirmAddress(picker) {
                this.address = picker.getValues()
                this.exam = [{
                    name: '全部考场',
                    value: 0
                }];
                this.loadVideo();
            },
            examinationConfirm(picker) {
                this.exam = picker.getValues()
                this.exam_change = picker.getValues()
                console.log(this.exam)
                this.loadVideo();
            },
            event_gokefu() {
                this.kefu.show = true
            },
            event_closeadv() {
                this.kefu.show = false
            },
            setData(params) {
                for (var n in params) {
                    this[n] = params[n]
                }
            },
            loadVideo() {

                var that = this
                /**
                 * 加载免费并且未指定考场的视频
                 */
                this.$app.pr('/api/video/freelist', {}).then((res) => {
                    that.freevideoData = res.data
                }).catch((res) => {
                    this.$wx.showToast({
                        title: '加载失败2',
                        icon: 'none'
                    })
                })

                /**
                 * 通过位置加载视频列表
                 */
                this.$app.pr('/api/video/lists.html', {
                    km: this.km,
                    location: this.$app.locationAddress,
                    examlocation: JSON.stringify(this.address),
                    examid: this.exam[0].value,
                    auto: !this.$app.locationAddress || this.$app.locationAddress == {} ? 1 : 0,
                    version: '0825',
                    test: 1
                }).then((res) => {
                    that.videoData = res.data.datalist
                    var exam = [{
                        name: '全部考场',
                        value: 0
                    }]
                    for (var n in res.data.examination) {
                        exam.push({
                            name: res.data.examination[n].name,
                            value: res.data.examination[n].id
                        })
                    }
                    that.examList = res.data.examination
                    that.examination[0].values = exam

                    if (res.data.autolocation !== false) {
                        that.videoData[res.data.km] = []
                    }
                    that.show = true
                }).catch((res) => {
                    console.log(res)
                    this.$wx.showToast({
                        title: '加载失败1',
                        icon: 'none'
                    })
                })
            },
            /**
             * 定位
             */
            locationPos() {
                var that = this;
                that.loadVideo();
                return false
                this.$app.getCurrentPosition().then((res) => {
                    console.log('定位成功')
                    console.log(res)
                    //通过坐标获取区域城市
                    var r = JSON.parse(res)
                    var locationInfo = new BMap.Geocoder()
                    var point = new BMap.Point(r.location.longitude, r.location.latitude)
                    locationInfo.getLocation(point, function (result) {
                        console.log('地区定位：');
                        console.log(result);
                        that.address = [result.addressComponents.province, result.addressComponents.city];
                        that.$app.locationAddressDetail = [result.addressComponents.province, result.addressComponents.city];
                        that.$refs.addressPicker.setValues([result.addressComponents.province, result.addressComponents.city]);
                        that.loadVideo();
                    }, {
                        poiRadius: 100,
                        numPois: 10
                    })
                }).catch((res) => {
                    this.$wx.showModal({
                        title: '提醒',
                        showCancel: false,
                        content: '请允许我们获取您的地理位置',
                        cancelText: '取消',
                        confirmText: '重新定位',
                        success: function (result) {
                            if (result.confirm) {
                                that.locationPos()
                            } else {
                                that.$app.locationAddressed = true;
                                that.$wx.showToast('定位失败')
                                that.$app.locationAddressDetail = ['云南省', '昆明市'];
                                that.$refs.addressPicker.setValues(that.$app.locationAddressDetail)
                                that.loadVideo()
                            }
                        }
                    });
                })
            },
            changeCt(i) {
                this.ct = i;
            },
            event_detail(item) {
                this.$wx.navigateTo({
                    url: '/videodetail?id=' + item.id,
                })
            },
            goTo(path) {
                this.$wx.navigateTo({
                    url: path,
                })
            },
            share_detail(item) {

                if (item.km2_0.length > 0) {
                    this.$wx.navigateTo({
                        url: '/share?id=' + item.km2_0[0].id,
                    })
                } else if (item.km2_1.length > 0) {
                    this.$wx.navigateTo({
                        url: '/share?id=' + item.km2_1[0].id,
                    })
                } else if (item.km3.length > 0) {
                    this.$wx.navigateTo({
                        url: '/share?id=' + item.km3[0].id,
                    })
                } else {
                    that.$wx.showToast('该考场下未查到相关线路视频');
                }
            },
            fx_click() {
                $(".fx_btn").toggleClass('active')
                $(".index_btn").toggleClass('active')
                $(".back_box span").toggleClass('active')
            },
            laod_data() {
                //定位并加载内容
                var that = this;
                //this.locationPos();
				that.loadVideo();//直接获取视频，因地理位置功能关闭
                this.userInfo = that.$store.state.userInfo;
                console.log("userInfo:");
                console.log(this.userInfo);
                this.$app.pr('/api/common/jsparams', {
                    url: that.$wx.getUrls()
                }).then((res) => {
                    wx.config(res.data.shareparam);
                    try {
                        wx.ready(function () {
                            wx.onMenuShareAppMessage({
                                title: res.data.share_name,
                                desc: res.data.share_desc,
                                link: 'https://jk.ioccn.com/video?scene=video_' + that.$store.state.userInfo.id,
                                imgUrl: res.data.share_image,
                                success: function () {
                                }
                            });
                            wx.onMenuShareTimeline({
                                title: res.data.share_name,
                                link: 'https://jk.ioccn.com/video?scene=video_' + that.$store.state.userInfo.id,
                                imgUrl: res.data.share_image
                            });
                        });
                    } catch (e) {
                        alert('fx error' + e)
                    }
                });
            },
            tabaction (i) {
                this.km = i
                this.loadVideo()
            }

        },
        created() {

        },
        mounted() {
            var that = this;
            if (that.$store.state.userInfo.unid == null) {
                //获取用户信息
                that.$https.post('/api/user/info.html', this.$qs.stringify({
                    token: that.$store.state.token
                })).then((res) => {
                    res.data.data.unid = res.data.data.id;
                    that.$store.state.userInfo = res.data.data;
                    that.laod_data();
                })
            } else {
                that.laod_data();
            }
        }

    }
</script>
<style scoped>
  .list_box {
    background-color: #fff;
    padding: 10px;
    margin: 10px 0;
  }

  .list_video {
    width: 100%;
    overflow-x: scroll;
    overflow-y: hidden;
    position: relative;
    height: 115px;
  }

  .list_video::-webkit-scrollbar {
    display: none;
  }

  .list_video ul {
    overflow: hidden;
    width: 200%;
    position: absolute;
    top: 0;
    left: 0;
  }

  .list_video li {
    width: 124px;
    padding: 0 10px;
    box-sizing: border-box;
    float: left;
    margin-left: 3px;
  }

  .list_video li .kc_video {
    width: 114px;
  }

  .list_video li .kc_video img {
    width: 100%;
    display: block;
  }

  .list_video li span {
    text-align: center;
    font-size: 3.3vw;
    line-height: 30px;
    display: inline-block;
    width: 100%;
    color: #666;
  }

  .xz_box {
    margin-top: 10px;
    background-color: #fff;
  }

  .xz_box ul li {
    height: 40px;
    line-height: 40px;
    font-size: 4vw;
    padding: 0 10px;
  }

  .xz_box ul li i {
    float: right;
    color: #999;
  }

  .xz_box ul li:first-child {
    border-bottom: 1px solid #ddd;
  }

  .kc_list {
    margin-top: 10px;
    background-color: #fff;
    /* padding: 10px; */
  }

  .kc_list h2 {
    font-size: .3rem;
    color: #1accf9;
    /* border-bottom: 1px solid #eee; */
    padding: .2rem .2rem;
    display: flex;
    align-items: center;
  }

  .kc_list .kc_title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #eee;
  }

  .kc_list .kc_title ol {
    display: flex;
    padding: 0 .2rem;
  }

  .kc_list .kc_title ol li {
    font-size: 3.4vw;
    color: #999;
    margin-left: .15rem;
    padding: 0.01rem .1rem;
    border-radius: .04rem;
  }

  .kc_list .kc_title ol li a {
    color: #999;
  }

  .kc_list .kc_title ol li.active {
    background-color: #1ACCF9;
    color: #fff;
  }

  .kc_list ul {
    margin-top: 2px;
    padding: 0 .2rem;
  }

  .kc_list ul li {
    overflow: hidden;
    padding-bottom: 10px;
    padding-top: 10px;
    border-bottom: 1px solid #eee;
  }

  .kc_list ul li:last-child {
    border-bottom: 0;
  }

  .kc_list ul li .kc_video {
    width: 35%;
    border-radius: 4px;
    float: left;
  }

  .kc_list ul li .kc_video img {
    width: 100%;
  }

  .kc_list ul li .kc_btbox {
    width: 60%;
    float: left;
    margin-left: 5%;
  }

  .kc_list ul li .kc_btbox h4 {
    font-size: 3.8vw;
    color: #333;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .kc_list ul li .kc_btbox p {
    font-size: 3.5vw;
    color: #999;
    line-height: 4.8vw;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    margin-top: 2px;
  }

  .kc_list ul li .kc_btbox .kc {
    font-size: 3.2vw;
    color: #1accf9;
    margin-top: 5px;
  }

  .kc_list ul li .kc_btbox .kc div {
    float: right;
  }

  .kc_list ul li .kc_btbox .kc span {
    color: #bbb;
    font-size: 3vw;
  }

  .kc_list ul li .kc_btbox .kc span i {
    font-size: 3.2vw;
    margin-right: 5px;
  }

  .kc_list ul li .kc_btbox .kc span:first-child {
    margin-right: 15px;
  }

  .back_box {
    position: fixed;
    right: 10px;
    bottom: 20%;
    width: 35px;
    height: 35px;
  }

  .back_box a {
    font-size: 16px;
    color: #fff;
    text-align: center;
    line-height: 35px;
    display: block;
    width: 35px;
    height: 35px;
    border-radius: 100%;
    background-color: #1accf9;
  }

  .back_box a.fx_btn,
  .back_box a.index_btn {
    position: absolute;
    top: 0;
    left: 0;
    transform: scale(0);
  }

  .back_box a.fx_btn {
    transition: ease-in-out .4s all;
  }

  .back_box a.fx_btn.active {
    top: -90px;
    transform: scale(1);
  }

  .back_box a.index_btn {
    transition: ease-in-out .3s all;
  }

  .back_box a.index_btn.active {
    top: -45px;
    transform: scale(1);
  }

  .back_box span {
    width: 35px;
    height: 35px;
    display: inline-block;
    border-radius: 100%;
    background: rgba(250, 250, 250, .6);
    box-shadow: 0px 2px 5px 0px rgba(26, 204, 249, 0.3);
    position: absolute;
    top: 0;
    left: 0;
    transition: ease-in-out .4s all;
  }

  .back_box span.active {
    transform: rotate(180deg);
    box-shadow: none;
    background-color: #1accf9;
  }

  .back_box span.active::before {
    background-color: #fff;
  }

  .back_box span.active::after {
    opacity: 0;
  }

  .back_box span::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 2px;
    height: 20px;
    border-radius: 1px;
    background-color: #1accf9;
    transition: ease-in-out .4s all;
  }

  .back_box span::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 20px;
    height: 2px;
    border-radius: 1px;
    background-color: #1accf9;
  }

  .yq_box img {
    width: 100%;
    display: block;
  }

  .fx_title {
    font-size: 4vw;
    text-align: center;
    line-height: 6vh;
    color: #1accf9;
  }

  .fx_block {
    width: 100%;
    height: 50px;
    line-height: 50px;
    background-color: #1accf9;
    text-align: center;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 9999;
    font-size: 3.5vw;
    color: #fff;
  }

  .wv-popup .weui-cells {
    font-size: 16px !important;
    color: #999 !important;
    margin-top: 0 !important;
  }

  .btn_box {
    padding-top: 10px;
  }

  .btn_box ul {
    display: flex;
  }

  .btn_box ul li {
    width: 50%;
    padding: 0 10px;
  }

  .btn_box ul li a {
    display: block;
    background-color: #1accf9;
    text-align: center;
    font-size: 3.5vw;
    line-height: 40px;
    color: #fff;
    border-radius: 6px;
  }

  .btn_box ul li:nth-child(2) a {
    background-color: #ff750f;
  }

  .jm_text {
    padding: 20px 10px;
    text-align: center;
    font-size: 3.8vw;
  }

  .jm_text span {
    color: #1accf9;
  }

  .nav_list {
    line-height: .88rem;
    overflow: hidden;
    background-color: #fff;
    height: .88rem;
  }

  .nav_list li {
    font-size: .3rem;
    width: 50%;
    float: left;
    text-align: center;
    position: relative;
    color: #444;
  }

  .nav_list li::before {
    content: "";
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 1px;
    height: .44rem;
    background-color: #ccc;
  }

  .nav_list li:last-child::before {
    width: 0;
  }

  .nav_list li.active {
    color: #1ACCF9;
  }

  .nav_list li.active::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 60%;
    height: 2px;
    background-color: #1accf9;
  }

  .kc_bq {
    font-size: .22rem;
    color: #fff;
    /* display: inline-block; */
    margin-left: .3rem;
    background-color: #1ACCF9;
    padding: .09rem .15rem;
    border-radius: .04rem;

  }

  .video_list h3 {
    font-size: .26rem;
    margin: 0;
    padding: 0 .2rem;
    color: #fff;
    margin-top: .2rem;
  }

  .video_list h3 span {
    background-color: #1ACCF9;
    display: inline-block;
    padding: .1rem;
    border-radius: .04rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/Video.vue